
import {
    CORE_LOAD_ITEM_INFORMATION_REQUEST,
    CORE_LOAD_ITEM_INFORMATION_SUCCESS,
    CORE_LOAD_ITEM_INFORMATION_FAILURE,

    REQUEST_STATE
} from '../types'
const requestState = REQUEST_STATE

export default {
    item: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_ITEM_INFORMATION_REQUEST:
                return state
            case CORE_LOAD_ITEM_INFORMATION_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_LOAD_ITEM_INFORMATION_FAILURE:
                return {}
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/item.js